angular
	.module 'App.Directive'
	.directive 'formUnload', ($window, $transitions, translate) ->
		restrict: 'A'
		require: '^form'
		link: (scope, element, attributes, formCtrl) ->
			unload = (event) =>
				event.preventDefault()
				event.returnValue = true
			transitionUnloadCancel = =>
				# Empty function
			transitionUnload = (transition) =>
				from = transition.from()
				to = transition.to()

				if from.name != to.name || transition.params('from') != transition.params('to')
					confirmed = $window.confirm(translate('wbo.messages.unsaved.data'))

					if confirmed
						transitionUnloadCancel()

					return confirmed

			scope.$watch(
				=> formCtrl.$dirty
				(isDirty) =>
					if isDirty
						transitionUnloadCancel()
						transitionUnloadCancel = $transitions.onBefore({}, transitionUnload)
						$transitions.onEnter({}, transitionUnloadCancel)
						$window.addEventListener('beforeunload', unload)
					else
						transitionUnloadCancel()

						$window.removeEventListener('beforeunload', unload)
			)
